import { InboxIcon, TrashIcon, UsersIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
const features = [
  {
    name: "Schnelle und effiziente Hilfe",
    description:
      "Wir bieten schnelle, nachhaltige Lösungen für Ihre Technikprobleme. Kontaktieren Sie uns für effektive Hilfe, die Ausfallzeiten minimiert und Komplexität eliminiert. Vertrauen Sie auf unsere Expertise.",
    to: "/service",
    icon: InboxIcon,
  },
  {
    name: "Kompetentes Team",
    description:
      "Unser Team besteht hauptsächlich aus Informatikstudenten, die umfangreiche Erfahrungen aus zahlreichen Kundenprojekten mitbringen. Ihre Expertise garantiert zuverlässige und professionelle Unterstützung bei all Ihren Technikfragen",
    to: "/about",
    icon: UsersIcon,
  },
  {
    name: "Für jeden geeignet: Ob privat oder gewerblich",
    description:
      " Privat oder gewerblich unser Service passt sich Ihren individuellen Bedürfnissen an. Wir helfen bei maßgeschneiderte Techniklösungen, die sowohl für Privatpersonen als auch für Unternehmen ideal sind.",
    to: "/contact",
    icon: TrashIcon,
  },
];

export default function FeatureSection() {
  return (
    <div className="bg-white py-24 sm:py-32">
      
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          3 Dienstleistungsmerkmale die für Unseren Studentischer Support sprechen


          </h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
          Techniksupport auf den Sie zählen können - von Studenten für alle

          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col">
                <dt className="text-base font-semibold leading-7 text-gray-900">
                  <div className="mb-6 flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-600">
                    <feature.icon
                      className="h-6 w-6 text-white"
                      aria-hidden="true"
                    />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-1 flex flex-auto flex-col text-base leading-7 text-gray-600">
                  <p className="flex-auto">{feature.description}</p>
                  <p className="mt-6">
                    <Link
                      to={feature.to}
                      className="text-sm font-semibold leading-6 text-indigo-600"
                    >
                      Mehr <span aria-hidden="true">→</span>
                    </Link>
                  </p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
